import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeviceTask } from '@era/device-task-management-sdk';
import { DevicesRouterStoreSelectors } from '../../../../stores/router';
import * as fromScheduledTasks from './device-scheduled-tasks.reducer';
import { DeviceScheduledTasksState } from './device-scheduled-tasks.state';

export const selectScheduledTasksState = createFeatureSelector<DeviceScheduledTasksState>('deviceScheduledTasks');

export const selectScheduledTasks = createSelector(
  selectScheduledTasksState,
  fromScheduledTasks.selectAllDeviceScheduledTasks
);

export const selectScheduledTasksByUdid = createSelector(
  selectScheduledTasks,
  DevicesRouterStoreSelectors.selectUdid,
  (scheduledTasks: DeviceTask[], udid: string) => scheduledTasks.filter((x) => x.udid === udid)
);
